// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import NumberOutlinedSvg from "@fishx/icons-svg/es/asn/NumberOutlined";
import FishxIcon from '../components/FishxIcon';

var NumberOutlined = function NumberOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: NumberOutlinedSvg
  }));
};

NumberOutlined.displayName = 'NumberOutlined';
export default React.forwardRef(NumberOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/NumberOutlined.js
// module id = 3182
// module chunks = 0